






























































































































































































































































































import {mapState} from "vuex";
import {Component, Prop, Vue} from "vue-property-decorator";
import formRules from "@/helpers/formRules";
import RouteTranslations from "@/locales/routerTranslations";
import Reservation from "@/models/reservation";
import {User} from "@/models/user";
import MenuManager from "@/components/MenuManager.vue";
import {
  CellarReservationsRequests,
  ProfileReservationsRequests,
  UtilitiesFunctions,
  UtilitiesRequests
} from "@/helpers";
import GuestReservations from "@/components/privateAreas/GuestReservations.vue";
import HostReservations from "@/components/privateAreas/HostReservations.vue";
import InfiniteLoading from "vue-infinite-loading";
import SearchFilters from "@/components/filters/SearchFilters.vue";
import SearchFiltersInfo from "@/components/filters/SearchFiltersInfo.vue";

@Component({
  components: {
    GuestReservations,
    HostReservations,
    InfiniteLoading,
    SearchFilters,
    SearchFiltersInfo,
    MenuManager
  },
  computed: {
    ...mapState({
      dialogManager: (state: any) => state.app.dialogManager,
      user: (state: any) => state.session.user
    })
  }
})
export default class ProfileDetail extends Vue {
  loading: boolean = false;
  user!: User;
  menuItems: Array<any> = [];
  infiniteId = 0;
  $refs: any["$refs"] & {
    form: any;
  };
  localUser?: User = new User();
  valid = false;
  myRules = {
    email: formRules.emailRules,
    password: formRules.passwordRules,
    confirmPwd: formRules.confirmPasswordRules
  };
  translations: any = RouteTranslations;
  section?: any = null;
  showReservations?: boolean = false;
  reservations: Reservation[] = [];
  confirmedReservations: any[] = [];
  completedReservations: any[] = [];
  waitingReservations: any[] = [];
  rejectedReservations: any[] = [];
  revokedReservations: any[] = [];
  provinces: any;
  page: number = 1;
  statuses: any[] = [];
  tmpQueryString: string | null = null;
  filtersTimeout: any = null;
  filters: any[] = [];
  resultsPerPage = 10;
  filtersCallBack: Object[] = [
    {
      id: "refresh",
      text: "",
      icon: "refresh",
      processFiltersCallback: (useDelay: boolean): void => this.handleProcessFilters(useDelay)
    }
  ];

  @Prop(String) private type!: string;

  get userEmailRules() {
    const [emailRule] = this.myRules.email;
    let rules = [];
    if (this.type === "signup") {
      rules.push(emailRule);
    }
    rules.push((v: any) => !!v || "Campo obbligatorio !");
    return rules;
  }

  mounted() {
    this.provinces = UtilitiesFunctions.provincesArray();
    this.setMenuItems();

    this.section = this.menuItems.filter(item => {
      if (this.user.type === "host")
        return item.link === 'hostPendingReservations';
      return item.link === 'userData';
    })[0];

    this.localUser = {
      ...this.$store.state.session.user,
      place: {...this.$store.state.session.user.place}
    };
    this.showReservations = this.section.showReservations;
    this.statuses = [
      {
        id: "waiting",
        name: this.$t("booking.statuses.waiting")
      },
      {
        id: "confirmed",
        name: this.$t("booking.statuses.confirmed")
      },
      {
        id: "revoked",
        name: this.$t("booking.statuses.revoked"),
        forHost: true
      },
      {
        id: "rejected",
        name: this.$t("booking.statuses.rejected"),
        forHost: true
      },
      {
        id: "completed",
        name: this.$t("booking.statuses.completed"),
        forHost: true
      }
    ];
    this.buildFilters();


    const selectedFilter: any = this.filters.filter(filter => {
      return ('selectedVal' in filter);
    });
    if (selectedFilter.length > 0) {
      this.$store.dispatch("app/refreshSearchFilters", {
        queryString: `${selectedFilter[0].queryParam}=${selectedFilter[0].selectedVal.id}`
      });
    }

  }

  buildFilters() {
    let itemList: any[] = [];
    switch (this.section.link) {
      case 'hostPendingReservations':
        itemList = this.statuses.filter(status => {
          return !status.forHost
        });
        this.filters = [
          {
            id: 0,
            type: "selectArray",
            label: this.$t("searchFilters.reservationStatus"),
            listType: "reservations",
            queryParam: "status",
            itemList,
            filterParentId: null,
            cssClass: "xs12 shrink md5"
          }
        ];
        break;
      case 'hostReservationHistory':
        itemList = this.statuses.filter(status => {
          return status.forHost
        });
        this.filters = [
          {
            id: 0,
            type: "selectArray",
            label: this.$t("searchFilters.reservationStatus"),
            listType: "reservations",
            queryParam: "status",
            itemList,
            filterParentId: null,
            cssClass: "xs12 shrink md5"
          },
          {
            id: 1,
            type: "inputDate",
            label: this.$t("searchFilters.reservationRange"),
            listType: "reservations",
            queryParam: ["start_created", "end_created"],
            selectedVal: [],
            min: null,
            rules: [],
            range: true,
            filterParentId: null,
            cssClass: "xs12 shrink md6"
          }
        ];
        break;
      case 'userReservations':
        this.filters = [
          {
            id: 0,
            type: "selectArray",
            label: this.$t("searchFilters.reservationStatus"),
            listType: "reservations",
            queryParam: "status",
            itemList: this.statuses,
            filterParentId: null,
            cssClass: "xs12 shrink md5"
          }
        ];
        break;
    }
  }

  handleProcessFilters(useDelay = true) {
    if (useDelay) {
      clearTimeout(this.filtersTimeout);
      this.filtersTimeout = setTimeout(() => {
        this.processFilters();
      }, 1000);
    } else {
      this.processFilters();
    }
  }

  processFilters() {
    const q = UtilitiesFunctions.buildFilteredRequest(this.filters);
    this.$store
      .dispatch("app/refreshSearchFilters", {
        queryString: q,
        filtersArray: JSON.parse(JSON.stringify(this.filters))
      })
      .then(() => {
      });
    if (this.tmpQueryString !== q || this.tmpQueryString === null) {
      this.page = 1;
      this.reservations = [];
      this.infiniteId += 1;
      // this.getExperiences();
      this.tmpQueryString = q;
    }
  }

  setMenuItems() {
    if (this.user.type === "host") {
      this.menuItems = [
        {
          label: this.$t("profileView.menuItems.pendingReservations"),
          link: "hostPendingReservations",
          showReservations: true
        },
        {
          label: this.$t("profileView.menuItems.reservationsHistory"),
          link: "hostReservationHistory",
          showReservations: true
        }
      ];
    } else {
      this.menuItems = [
        {
          label: this.$t("profileView.menuItems.accessData"),
          link: "userData"
        },
        {
          label: this.$t("profileView.menuItems.userProfile"),
          link: "userProfile"
        },
        {
          label: this.$t("profileView.menuItems.pendingReservations"),
          link: "userReservations",
          showReservations: true
        }
      ];
    }
  }

  getReservations($state?: any, filters: string = "") {
    if (this.loading) return;
    this.loading = true;
    const requestComponent = (this.localUser && this.localUser.type === 'host') ? CellarReservationsRequests : ProfileReservationsRequests;
    let requestFilters: any = filters;

    const statusFilters = this.filters[0];
    if ((this.section.link === 'hostReservationHistory' || this.section.link === 'hostPendingReservations') && (!statusFilters.selectedVal || statusFilters.selectedVal.length === 0)) {
      requestFilters += '&' + statusFilters.queryParam + '=' + statusFilters.itemList.map((status: any) => status.id).join(",");
    }

    return requestComponent.fetchAll(requestFilters)
      .then((response: any) => {
        if (response.length) {
          this.page += 1;
          this.reservations = this.reservations.concat(response);
          $state.loaded();
        }
        if (response.length < this.resultsPerPage) {
          $state.complete();
        }
        $state.loaded();
        this.loading = false;
      })
      .catch((error: Error) => {
        this.loading = false;
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
      });
  }

  getFilters(): any {
    let filters = this.$store.state.app.searchFilters.queryString;
    filters += (filters ? '&' : '') + "page=" + this.page + "&per_page=" + this.resultsPerPage;
    return filters;
  }

  loadMoreReservations($state?: any) {
    this.getReservations($state, this.getFilters());
  }

  navManager(item: any) {
    this.section = item;
    this.showReservations = item.showReservations || false;
    this.tmpQueryString = null;
    this.buildFilters();
    this.processFilters();
  }

  handleResetPassword(type: string) {
    this.$store
      .dispatch("app/setDialog", {
        type: type,
        state: true
      })
      .then(() => {
      })
      .catch(error => {
        console.error(error);
      });
  }

  saveUserData() {
    const userData = new User().requestSerialize(this.localUser);
    const relationships: any[] = [];
    // relationships.push({
    //   relName: "place",
    //   models: { _type: "place", id: "abx" }
    // });
    if (this.localUser)
      UtilitiesRequests.editProfile(
        this.localUser.type,
        userData,
        relationships
      )
        .then(() => {
          this.$store.dispatch("session/updateCurrentUserdata", this.localUser);
          this.$store.dispatch("app/setSnackbarMessage", {
            message: this.$t("profileView.userProfile.successMessage"),
            color: "green"
          });
        })
        .catch((error: Error) => {
          this.$store.dispatch("app/setSnackbarMessage", {
            message: error,
            color: "red"
          });
        });
  }

  logout() {
    const toRoute = UtilitiesFunctions.handleRoute("home");
    this.$store
      .dispatch("session/logout")
      .then((): any => this.$router.push({path: toRoute}))
      .catch((error: Error) => {
        this.$store.dispatch("app/setSnackbarMessage", {
          message: error,
          color: "red"
        });
        this.$store.commit("session/cleanCurrentUser");
      });
  }
}
